

(function () {
  const KEY = 'shopify_wishlist';

  function get() {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  }

  function save(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
    updateCount();
  }

  function toggle(product) {
    let items = get();
    const index = items.findIndex(i => i.id == product.id);

    if (index > -1) {
      items.splice(index, 1);
    } else {
      items.push(product);
    }
    save(items);
  }

  function isActive(id) {
    return get().some(i => i.id == id);
  }

  function updateCount() {
    document.querySelectorAll('.wishlist-count').forEach(el => {
      el.textContent = get().length;
    });
  }

  // 🔥 EVENT DELEGATION (Dawn safe)
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.wishlist-btn');
    if (!btn) return;

    e.preventDefault();

    const product = {
  id: btn.dataset.id,
  title: btn.dataset.title,
  url: btn.dataset.url,
  image: btn.dataset.image
};

    toggle(product);
    btn.classList.toggle('active');
  });

  // 🔁 Sync state on load & section reload
  function syncButtons() {
    document.querySelectorAll('.wishlist-btn').forEach(btn => {
      if (isActive(btn.dataset.id)) {
        btn.classList.add('active');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    updateCount();
    syncButtons();
  });

  document.addEventListener('shopify:section:load', syncButtons);

  window.Wishlist = { get, toggle };
})();








